import React, { useState, useEffect } from 'react';
import { auth } from './firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import './Login.css';
import { STAFF_LOGO, STAFF_NAME } from './utils/brand';


function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [notice, setNotice] = useState('');

  // Surface the reason set by the admin panel's inactivity auto-logout, once.
  useEffect(() => {
    try {
      if (localStorage.getItem('logoutReason') === 'inactivity') {
        setNotice('You were logged out due to inactivity.');
        localStorage.removeItem('logoutReason');
      }
    } catch (_) { /* localStorage unavailable — skip */ }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // The old lock-out counter (loginAttempts) is gone (owner, 19 Oct 2026): anyone could write it,
    // so it could lock the owner out or be reset. Firebase's own sign-in throttling stands in —
    // 'auth/too-many-requests' below.
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onLogin();
    } catch (err) {
      const code = err?.code || '';
      let msg;
      if (code === 'auth/user-not-found') {
        msg = 'No login account exists for this email. Please contact your admin.';
      } else if (code === 'auth/wrong-password' || code === 'auth/invalid-credential') {
        msg = 'Wrong password. Please try again or ask your admin to reset it.';
      } else if (code === 'auth/invalid-email') {
        msg = 'Invalid email address.';
      } else if (code === 'auth/too-many-requests') {
        msg = 'Too many attempts. Please wait a few minutes and try again.';
      } else if (code === 'auth/network-request-failed') {
        msg = 'Network error. Please check your connection and try again.';
      } else {
        msg = 'Invalid email or password. Please try again.';
      }

      setError(msg);
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        {/* One login screen serves both companies, so the brand follows the
            domain — this previously hardcoded Mobilistan, meaning Al Sami staff
            were greeted by the wrong company's name and mark. */}
        <img src={STAFF_LOGO} alt={STAFF_NAME} className="login-logo login-logo-mark" />
        <h2>{STAFF_NAME} Staff Login</h2>
        <p>Sign in to {STAFF_NAME}</p>
        {notice && (
          <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1e40af', borderRadius: 8, padding: '10px 12px', fontSize: 14, marginBottom: 12, textAlign: 'center' }}>
            {notice}
          </div>
        )}
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;